import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import SubmitCommentButton from "../SubmitCommentButton";


export default function NewPatternComment({ pattern_id, token, userId, update}) {
    const [comment, setComment] = useState("");

    const getComment = () => {return comment;}

    return (
        <div key={"first-comment"} className="comment-box">
            <dt className="comment-header">
                <Row>
                    <div className="col-sm-10"><b>Be the first to add a comment!</b></div>
                </Row>
            </dt>
            <dd className="comment-editor">
                <Form.Control
                    as="textarea"
                    rows="4"
                    placeholder="Enter your comment here"
                    style={{height: "64px"}}
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                />
            </dd>
            <dd className="comment-timestamp">
                <React.Fragment>
                    <SubmitCommentButton
                        update={update}
                        userId={userId}
                        pattern_id={pattern_id}
                        token={token}
                        resetComment={() => setComment("")}
                        getComment={getComment()}
                        buttonStyle={{marginBottom: 5, marginRight: 10}}
                        buttonText={"Submit Comment"}
                    />
                </React.Fragment>
            </dd>
        </div>);
}
